import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../supabase";

export default function Header({ language, toggleLanguage, isScrolled }) {
  const [user, setUser] = useState(null);
  const [firstLetter, setFirstLetter] = useState(null);
  const [role, setRole] = useState(null);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const isPasswordRecoveryPage = location.pathname === "/reset-password-confirm";
  const isPasswordRecoveryInProgress =
    sessionStorage.getItem("passwordRecoveryInProgress") === "true";

  // 👑 جلب المستخدم + role
  const fetchUser = useCallback(async () => {
    if (isPasswordRecoveryPage || isPasswordRecoveryInProgress) {
      setUser(null);
      setFirstLetter(null);
      setRole(null);
      return;
    }

    const { data } = await supabase.auth.getUser();

    if (data?.user) {
      setUser(data.user);

      const { data: profile } = await supabase
        .from("profiles")
        .select("first_name, role")
        .eq("id", data.user.id)
        .single();

      if (profile?.first_name) {
        setFirstLetter(profile.first_name[0].toUpperCase());
      }

      setRole(profile?.role || null);
      console.log("PROFILE:", profile);
console.log("ROLE:", profile?.role);
    }
    
  }, [isPasswordRecoveryInProgress, isPasswordRecoveryPage]);

  // جلب بيانات المستخدم عند التحميل
  useEffect(() => {
    if (isPasswordRecoveryPage || isPasswordRecoveryInProgress) {
      setUser(null);
      setFirstLetter(null);
      setRole(null);
      return;
    }

    fetchUser();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === "PASSWORD_RECOVERY") {
          sessionStorage.setItem("passwordRecoveryInProgress", "true");
          setUser(null);
          setFirstLetter(null);
          setRole(null);
          return;
        }

        if (session?.user) {
          fetchUser();
        } else {
          setUser(null);
          setFirstLetter(null);
          setRole(null);
        }
      }
    );

    return () => listener.subscription.unsubscribe();
  }, [fetchUser, isPasswordRecoveryPage, isPasswordRecoveryInProgress]);

  // 🚪 تسجيل خروج
  const handleLogout = async () => {
    await supabase.auth.signOut();

    localStorage.removeItem("auth_token");
    sessionStorage.removeItem("passwordRecoveryInProgress");

    setUser(null);
    setFirstLetter(null);
    setRole(null);
    setMobileMenuOpen(false);

    navigate("/login");
  };

  // روابط الموقع
  const navItems = [
    { id: "why-us", en: "WHY US", ar: "لماذا نحن" },
    { id: "about", en: "ABOUT", ar: "من نحن" },
    { id: "services", en: "SERVICES", ar: "خدماتنا" },
    { id: "process", en: "PROCESS", ar: "ألية" },
    { id: "people", en: "EXECUTIVE TEAM", ar: "الفريق التنفيذي" },
    { id: "partners", en: "OUR PARTNERS", ar: "شركاؤنا" },
    { id: "contact", en: "CONTACT US", ar: "اتصل بنا" },
    { id: "feasibility", en: "FEASIBILITY STUDIES", ar: "دراسات الجدوى" },
  ];

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      
      {/* Logo */}
      <div className="logo-container">
        <img src="/img/jr-watermark.png" alt="Logo" className="logo-img" />

        <div className="company-name">
          <span className="main">
            {language === "ar"
              ? "الجبرية التجارية"
              : "Al Jabriyah Commercial"}
          </span>
          <br />
          <span className="sub">
            {language === "ar"
              ? "Al Jabriyah Commercial"
              : "الجبرية التجارية"}
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`main-nav ${mobileMenuOpen ? "active" : ""}`}>
        <ul>
          {navItems.map((item) => (
            <li key={item.id}>
              {item.id === "feasibility" ? (
                <Link
                  to="/feasibility"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {language === "ar" ? item.ar : item.en}
                </Link>
              ) : (
                <Link
                  to={`/#${item.id}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {language === "ar" ? item.ar : item.en}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {/* Right side */}
      <div className="header-right">
        <button
          className={`mobile-menu-btn ${mobileMenuOpen ? "open" : ""}`}
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen((open) => !open)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        {/* Language */}
        <button className="lang-btn" onClick={toggleLanguage}>
          {language === "en" ? "AR" : "EN"}
        </button>

        {/* 👑 زر المالك (الكوبونات) */}
        {user && role === "owner" && (
          <Link to="/admin/coupons" className="admin-link">
            🎟 Coupons
          </Link>
        )}

        {/* Login / User */}
        {!user ? (
          <Link to="/login" className="user-btn circle-btn">
            {language === "ar" ? "تسجيل دخول" : "Login"}
          </Link>
        ) : (
          <div className="user-container">
            <button
              className="user-btn circle-btn"
             onClick={() => navigate("/dashboard")}
            >
              {firstLetter}
            </button>

           
          </div>
        )}

        {/* Mobile menu */}
     
      </div>
    </header>
  );
}
